module.exports = __webpack_public_path__ + "img/5.aca8246e.png";